// Color-by legend — renders ONLY while color-by is active (A24/NG11). Lists each mapped category +
// its colour swatch, plus the `Other` bucket when the palette overflowed. Colours come from the
// scale (mapThemes) — this component never mints a colour.

import type { CategoryLegendEntry } from '../map/mapThemes';

export function SpatialMapLegend({ entries }: { entries: CategoryLegendEntry[] }) {
  if (entries.length === 0) return null;
  return (
    <div
      data-testid="spatial-map-legend"
      className="pointer-events-none absolute bottom-2 left-2 z-10 max-h-[45%] max-w-[45%] overflow-auto rounded-md border border-border/60 bg-background/85 p-1.5 text-[11px] shadow-sm backdrop-blur-sm"
    >
      <ul className="space-y-0.5">
        {entries.map((entry) => (
          <li key={entry.category} className="flex items-center gap-1.5">
            <span
              aria-hidden
              className="inline-block h-2.5 w-2.5 flex-shrink-0 rounded-[3px]"
              style={{ backgroundColor: entry.color }}
            />
            <span className="truncate text-foreground/90" title={entry.category}>
              {entry.category}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
